<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      form-label-width="110px"
      unit="申请提现管理"
      edit-title
      id-key="LabelId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :close-on-saved="false"
      :show-save-button="false"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="流水号" prop="DocNo">
              <span>{{data.DocNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请提现的客户" prop="TradeUnitName">
              <span>{{data.TradeUnitName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户性质" prop="TradeUnitType">
              <span>{{data.TradeUnitType==2?'批发':data.TradeUnitType==3?'供应商':'零售'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提现金额" prop="Amount">
              <span>{{data.Amount}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button size="mini" type="danger" @click="cancelExamine" v-if="data.Status==2">弃 审</el-button>
        <el-button size="mini" type="success" @click="examine" v-else>通 过</el-button>
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        Amount: "",
        DocNo: "",
        Person: "",
        Phone: "",
        Status: 0,
        TradeUnitCode: "",
        TradeUnitId: "",
        TradeUnitName: "",
        TradeUnitType: "",
        WithdrawCashId: "",
      },
      api: require("@/api/ba/withdrawcash").default,
      rules: {
        LabelCode: [{ required: true, message: "标签编码不能为空" }],
        LabelName: [{ required: true, message: "标签名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(row) {

    },
        examine() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.examine(this.data.WithdrawCashId).then(res => {
          if(res.Code ==0) {
            this.$message.success("审核成功")
            this.readonly = true
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm("确认弃审吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.cancelExamine(this.data.WithdrawCashId).then(res => {
          if(res.Code ==0) {
            this.$message.success("弃审成功")
            this.readonly = false
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
  },
};
</script>